<template>
  <div>
    <span>
      <select
        class="for-popup input_full-width notranslate"
        v-model="$data[timePickerId === 1 ? 'arrivalTime' : (timePickerId === 2 ? 'storageTimeFrom' : (timePickerId === 3 ? 'storageTimeEnd' : ''))]"
        @change="time"
        aria-required="true"
        translate="no"
        :id="`timePicker-${timePickerId}`"
      >
        <option class="disoption notranslate" value="" disabled selected translate="no">{{ disOption }}</option>
        <option
          v-for="time in getTime(timePickerId)"
          class="option notranslate"
          :key="time"
          :value="time"
          translate="no"
        >
          {{ time }}
        </option>
      </select>
      <Popup v-if="timePickerId === 2 || timePickerId === 3" :fieldName='""'
             :header='timePickerId === 2 ? "Storage From" : (timePickerId === 3 ? "Storage End" : "")'/>
    </span><br><br>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Popup from '@/components/Popup'
import $ from 'jquery'
const { isHighSeasonBookingDate } = require('@/utils/bookingDate')

export default {
  name: 'TimePicker',
  props: ['timePickerId', 'disOption', 'infoFrom', 'infoTo'],
  components: { Popup },
  computed: {
    ...mapGetters(['getOrderInfo', 'getStorageInfo']),
    selectedServiceDate () {
      if (this.timePickerId === 1) return this.getOrderInfo.arrivalDate
      if (this.timePickerId === 2) return this.getStorageInfo.storageDateFrom
      return this.getStorageInfo.storageDateEnd
    }
  },
  data () {
    return {
      arrivalTime: '',
      storageTimeFrom: '',
      storageTimeEnd: '',
      // Low season times (for Storage)
      times_null: [''],
      times: [
        '4 am - 5 am (+50€)', '5 am - 6 am (+35€)', '6 am - 7 am (+25€)', '7 am - 8 am (+15€)',
        '8 am - 9 am', '9 am - 10 am',
        '10 am - 11 am', '11 am - 12 pm', '12 pm - 1 pm',
        '1 pm - 2 pm', '2 pm - 3 pm', 
        '3 pm - 4 pm', '4 pm - 5 pm',
        '5 pm - 6 pm (+15€)', '6 pm - 7 pm (+25€)', '7 pm - 8 pm (+35€)',
        'Other'
      ],
      timesAir: [
        '1 pm - 2 pm', '2 pm - 3 pm', 
        '3 pm - 4 pm', '4 pm - 5 pm',
        '5 pm - 6 pm (+15€)', '6 pm - 7 pm (+25€)', '7 pm - 8 pm (+35€)',
        'Other'
      ],
      timesAirHotel: [
        '4 am - 5 am (+50€)', '5 am - 6 am (+35€)', '6 am - 7 am (+25€)', '7 am - 8 am (+15€)',
        '8 am - 9 am', '9 am - 10 am',
        '10 am - 11 am (+10€)', '11 am - 12 pm (+25€)', '12 pm - 1 pm (+45€)',
        'Other'
      ],
      timesAirCruise: [
        '4 am - 5 am (+50€)', '5 am - 6 am (+35€)', '6 am - 7 am (+25€)', '7 am - 8 am (+15€)',
        '8 am - 9 am', '9 am - 10 am',
        '10 am - 11 am', 
        'Other'
      ],
      timesAirPrivate: [
        '4 am - 5 am (+50€)', '5 am - 6 am (+35€)', '6 am - 7 am (+25€)', '7 am - 8 am (+15€)',
        '8 am - 9 am', '9 am - 10 am',
        '10 am - 11 am (+10€)', '11 am - 12 pm (+25€)', '12 pm - 1 pm (+45€)',
        'Other'
      ],
      timesPrivateAir: [
        '1 pm - 2 pm', '2 pm - 3 pm',
        '3 pm - 4 pm', '4 pm - 5 pm',
        '5 pm - 6 pm (+15€)', '6 pm - 7 pm (+25€)', '7 pm - 8 pm (+35€)',
        'Other'
      ],
      // High season times (for Storage)
      times_high: [
        '4 am - 5 am (+35€)', '5 am - 6 am (+25€)', '6 am - 7 am (+15€)',
        '7 am - 8 am', '8 am - 9 am', '9 am - 10 am',
        '10 am - 11 am', '11 am - 12 pm', '12 pm - 1 pm',
        '1 pm - 2 pm', '2 pm - 3 pm', '3 pm - 4 pm',
        '4 pm - 5 pm', '5 pm - 6 pm', '6 pm - 7 pm',
        '7 pm - 8 pm (+15€)', '8 pm - 9 pm (+25€)',
        'Other'
      ],
      timesAir_high: [
        '1 pm - 2 pm', '2 pm - 3 pm', '3 pm - 4 pm',
        '4 pm - 5 pm', '5 pm - 6 pm', '6 pm - 7 pm',
        '7 pm - 8 pm (+15€)', '8 pm - 9 pm (+25€)',
        'Other'
      ],
      timesAirCruise_high: [
        '4 am - 5 am (+35€)', '5 am - 6 am (+25€)', '6 am - 7 am (+15€)',
        '7 am - 8 am', '8 am - 9 am', '9 am - 10 am',
        '10 am - 11 am',
        'Other'
      ],
      timesAirHotel_high: [
        '4 am - 5 am (+35€)', '5 am - 6 am (+25€)', '6 am - 7 am (+15€)',
        '7 am - 8 am', '8 am - 9 am', '9 am - 10 am',
        '10 am - 11 am (+10€)', '11 am - 12 pm (+25€)', '12 pm - 1 pm (+45€)',
        'Other'
      ],
      timesAirPrivate_high: [
        '4 am - 5 am (+35€)', '5 am - 6 am (+25€)', '6 am - 7 am (+15€)',
        '7 am - 8 am', '8 am - 9 am', '9 am - 10 am',
        '10 am - 11 am (+10€)', '11 am - 12 pm (+25€)', '12 pm - 1 pm (+45€)',
        'Other'
      ],
      timesPrivateAir_high: [
        '1 pm - 2 pm', '2 pm - 3 pm', '3 pm - 4 pm',
        '4 pm - 5 pm', '5 pm - 6 pm', '6 pm - 7 pm',
        '7 pm - 8 pm (+15€)', '8 pm - 9 pm (+25€)',
        'Other'
      ]
    }
  },
  created () {
    if (this.getOrderInfo.arrivalTime) {
      this.arrivalTime = this.getOrderInfo.arrivalTime
    }

    if (this.getStorageInfo.storageTimeFrom) {
      this.storageTimeFrom = this.getStorageInfo.storageTimeFrom
    }

    if (this.getStorageInfo.storageTimeEnd) {
      this.storageTimeEnd = this.getStorageInfo.storageTimeEnd
    }
  },
  methods: {
    ...mapMutations(['addTime']),
    time () {
      switch (this.timePickerId) {
        case 1:
          if (this.arrivalTime !== 'Other') {
            this.addTime({
              arrivalTime: this.arrivalTime
            })
          } else {
            this.addTime({
              arrivalTime: ''
            })
          }
          break
        case 2:
          if (this.storageTimeFrom !== 'Other') {
            this.addTime({
              storageTimeFrom: this.storageTimeFrom
            })
          } else {
            this.addTime({
              storageTimeFrom: '' // this.storageTimeFrom
            })
          }
          break
        case 3:
          if (this.storageTimeEnd !== 'Other') {
            this.addTime({
              storageTimeEnd: this.storageTimeEnd
            })
          } else {
            this.addTime({
              storageTimeEnd: ''
            })
          }
          break
      }
    },
    getTime (timePickerId) {
      console.log('***** Entering gettime() function')
      var userDate = timePickerId === 1 ? this.getOrderInfo.arrivalDate : (timePickerId === 2 ? this.getStorageInfo.storageDateFrom : this.getStorageInfo.storageDateEnd)
      const highseason = isHighSeasonBookingDate(userDate)
      var newtime = []
      //
      // Check individual cases of services
      //
      // Hotel - Airport and Cruise - Airport
      if ((this.infoFrom === 'Hotel' && this.infoTo === 'Airport') || (this.infoFrom === 'Cruise' && this.infoTo === 'Airport')) {
        console.log('1 - enter: ' + this.infoFrom + ' / ' + this.infoTo)
        newtime = highseason ? this.timesAir_high : this.timesAir
      } else if (this.infoFrom === 'Airport' && this.infoTo === 'Hotel') { // Airport - Hotel
        console.log('2 - enter: ' + this.infoFrom + ' / ' + this.infoTo)
        newtime = highseason ? this.timesAirHotel_high : this.timesAirHotel
      } else if ((this.infoFrom === 'Private Address' && this.infoTo === 'Airport')) { // Private - Airport
        console.log('3 - enter: ' + this.infoFrom + ' / ' + this.infoTo)
        newtime = highseason ? this.timesPrivateAir_high : this.timesPrivateAir
      } else if ((this.infoFrom === 'Airport' && this.infoTo === 'Private Address')) { // Airport - Private
        console.log('3.1 - enter: ' + this.infoFrom + ' / ' + this.infoTo)
        newtime = highseason ? this.timesAirPrivate_high : this.timesAirPrivate
      } else if ((this.infoFrom === 'Airport' && this.infoTo === 'Cruise')) { // Airport - Cruise
        console.log('3.2 - enter: ' + this.infoFrom + ' / ' + this.infoTo)
        newtime = highseason ? this.timesAirCruise_high : this.timesAirCruise
      } else { // Storage, Airport-Private (Hotel-Cruise and Cruise-Hotel does not have a timepicker)
        /* console.log('enter-4: ' + this.infoFrom)
        console.log('enter-4: ' + this.infoTo)
        console.log('xx: ' + this.getOrderInfo.from + ' / ' + this.getOrderInfo.to)
        */
        newtime = highseason ? this.times_high : this.times
        return newtime
      }
      return newtime
    },
    clearTimeIfUnavailable () {
      const field = this.timePickerId === 1
        ? 'arrivalTime'
        : (this.timePickerId === 2 ? 'storageTimeFrom' : 'storageTimeEnd')
      const selectedTime = this[field]

      if (selectedTime && !this.getTime(this.timePickerId).includes(selectedTime)) {
        this[field] = ''
        this.addTime({ [field]: '' })
      }
    }
  },
  watch: {
    selectedServiceDate (newDate, oldDate) {
      if (newDate !== oldDate) this.clearTimeIfUnavailable()
    },
    arrivalTime: {
      handler: function (val) {
        if (val === 'Other') {
          alert('Contact office for special hours')
          $(`#timePicker-${this.timePickerId}`).css('color', 'red')
        } else if (val === '') {
          $(`#timePicker-${this.timePickerId}`).css('color', 'red')
        } else {
          $(`#timePicker-${this.timePickerId}`).css('color', 'black')
        }
      }
    },
    storageTimeFrom: {
      handler: function (val) {
        if (val === 'Other') {
          alert('Contact office for special storage hours')
          $(`#timePicker-${this.timePickerId}`).css('color', 'red')
        } else if (val === '') {
          $(`#timePicker-${this.timePickerId}`).css('color', 'red')
        } else {
          $(`#timePicker-${this.timePickerId}`).css('color', 'black')
        }
      }
    },
    storageTimeEnd: {
      handler: function (val) {
        if (val === 'Other') {
          alert('Contact office for special storage hours')
          $(`#timePicker-${this.timePickerId}`).css('color', 'red')
        } else if (val === '') {
          $(`#timePicker-${this.timePickerId}`).css('color', 'red')
        } else {
          $(`#timePicker-${this.timePickerId}`).css('color', 'black')
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  input, select {
    width: 20em;
    line-height: 3em;
    border: 1px solid #cccccc;
    border-radius: 10px;
    box-shadow: 0px 1px 2px 1px #cccccc;
    text-align: center;
    color:#727272;
  }

  select {
    height: 40px;
    cursor: pointer;
  }

  // .disoption {
  //   color: rgb(139, 139, 139);
  // }

  // option:disabled {
  //   color: rgb(139, 139, 139);
  // }

  option {
    background-color: #d4d5d6;
    margin: 6em 1em 1em 1em;
    font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
    font-weight: 300;
    font-size: 20px;
    letter-spacing: 0.1rem;
    color:#727272;
  }
</style>
